import LocaleService from 'infrastructure/i18n/LocaleService';
import { ColumnProps } from 'modules/inbound/shared/domain/ColumnsTypes';
import { NameValues } from 'modules/inbound/shared/domain/NameValues';
import { InboundText } from 'modules/inbound/shared/infraestructure/i18n/inboundText';
import { InboundTranslations } from 'modules/inbound/shared/infraestructure/i18n/typing';
import { JitText } from '../infrastructure/i18n/JitText';
import { JitTranslations } from '../infrastructure/i18n/typing';

const jitTranslations: JitTranslations & InboundTranslations = {
  ...JitText[LocaleService.getLanguage()],
  ...InboundText[LocaleService.getLanguage()]
};

export enum ColumnKeys {
  code = 'code',
  providerCode = 'providerCode',
  families = 'families',
  description = 'description',
  comment = 'comment',
  inbounder = 'inbounder',
  providerBusinessCode = 'providerBusinessCode',
  providerBusinessName = 'providerBusinessName',
  oLBusinessCode = 'oLBusinessCode',
  olBusinessName = 'olBusinessName',
  lines = 'lines',
  sequencerCoverage = 'sequencerCoverage',
  margin = 'margin',
  OLProvider = 'OLProvider',
  OLStock = 'OLStock',
  OLUpdated = 'OLUpdated',
  T1Provider = 'T1Provider',
  T1Stock = 'T1Stock',
  T1Updated = 'T1Updated',
  providerType = 'providerType',
  models = 'models',
  SEQUENCERCOVERAGESTATUS = 'status',
  quantityStock = 'quantityStock',
  m100LaunchesCount = 'm100LaunchesCount',
  stockSequence = 'stockSequence',
  coverageSequence = 'coverageSequence',
  coverageStoppedAt = 'coverageStoppedAt',
  lineStoppedAt = 'lineStoppedAt'
}

export const PART_COVERAGE_COLUMNS: ColumnProps[] = [
  {
    key: NameValues.CODE,
    value: jitTranslations.code,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.code,
        key: NameValues.CODE,
        value: jitTranslations.code,
        sortable: true
      }
    ]
  },
  /* {
    key: NameValues.PROVIDER_CODE,
    value: jitTranslations.providerCode,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.providerCode,
        key: NameValues.PROVIDER_CODE,
        value: jitTranslations.providerCode,
        sortable: false,
        tooltipInfo: jitTranslations.providerPartTooltipInfo
      }
    ]
  },*/

  {
    key: NameValues.DESCRIPTION,
    value: jitTranslations.description,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.description,
        key: NameValues.DESCRIPTION,
        value: jitTranslations.description,
        sortable: true,
        resize: true
      }
    ]
  },
  {
    key: NameValues.COMMENT,
    value: jitTranslations.comment,
    sortable: false,
    isVisibleCheck: true,
    headerVisible: false,
    columns: [
      {
        uiKey: ColumnKeys.comment,
        key: NameValues.COMMENT,
        value: jitTranslations.comment,
        sortable: false,
        resize: true,
        tooltipInfo: jitTranslations.commentsTooltip
      }
    ]
  },
  {
    key: NameValues.INBOUNDER,
    value: jitTranslations.inbounder,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.inbounder,
        key: NameValues.INBOUNDER,
        value: jitTranslations.inbounder,
        sortable: true,
        resize: true
      }
    ]
  },
  {
    key: NameValues.SEQUENCERCOVERAGESTATUS,
    value: jitTranslations.sequencer_coverage_status,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.SEQUENCERCOVERAGESTATUS,
        key: NameValues.SEQUENCERCOVERAGESTATUS,
        value: jitTranslations.sequencer_coverage_status,
        sortable: true,
        resize: true,
        tooltipInfo: jitTranslations.sequencerCoverageStatusTooltip
      }
    ]
  },
  /* {
    key: NameValues.FAMILIES,
    value: jitTranslations.family,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.families,
        key: NameValues.FAMILIES,
        value: jitTranslations.family,
        sortable: true,
        resize: true
      }
    ]
  },*/
  {
    key: NameValues.LINES,
    value: jitTranslations.line,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.lines,
        key: NameValues.LINES,
        value: jitTranslations.line,
        sortable: true,
        resize: true
      }
    ]
  },
  {
    key: NameValues.QUANTITYSTOCK,
    value: jitTranslations.stock_coverage,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.quantityStock,
        key: NameValues.QUANTITYSTOCK,
        value: jitTranslations.stock_coverage,
        sortable: true,
        resize: true
      }
    ]
  },
  {
    key: NameValues.COVERAGE_WITH,
    value: jitTranslations.coverageWithLabel,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.sequencerCoverage,
        key: NameValues.SEQUENCER_COVERAGE,
        value: jitTranslations.sequencerCoverage,
        sortable: true,
        tooltipInfo: jitTranslations.T1Stock2Tooltip
      }
      /*{
        uiKey: ColumnKeys.margin,
        key: NameValues.MARGIN,
        value: jitTranslations.margin,
        sortable: true,
        tooltipInfo: jitTranslations.T2TransitsTooltip,
        align: 'right'
      }*/
    ]
  },
  {
    key: NameValues.LOGISTIC_OPERATOR,
    value: jitTranslations.OL,
    headerVisible: true,
    headerSpan: 2,
    isHeaderExpandable: true,
    isHeaderExpanded: false,
    columnVisibleOnHeaderCollapsed: NameValues.LOGISTIC_OPERATOR_CODE,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.oLBusinessCode,
        key: NameValues.LOGISTIC_OPERATOR_CODE,
        value: jitTranslations.OLBusinessCode,
        sortable: false,
        resize: true
      },
      {
        uiKey: ColumnKeys.olBusinessName,
        key: NameValues.LOGISTIC_OPERATOR_NAME,
        value: jitTranslations.OlBusinessName,
        sortable: false,
        resize: true
      }
      /**{{
        uiKey: ColumnKeys.OLStock,
        key: NameValues.SEQUENCER_STOCK,
        value: jitTranslations.OLStock,
        sortable: false,
        resize: true,
        align: 'right'
      }
      
        uiKey: ColumnKeys.OLUpdated,
        key: NameValues.LAST_UPDATED,
        value: jitTranslations.OLUpdated,
        sortable: false,
        resize: true,
        tooltipInfo: jitTranslations.OLUpdatedTooltip
      }*/
    ]
  },
  {
    key: NameValues.PROVIDER_TIER_1,
    value: jitTranslations.T1,
    headerVisible: true,
    headerSpan: 2,
    isVisibleCheck: true,
    isHeaderExpandable: true,
    isHeaderExpanded: false,
    columnVisibleOnHeaderCollapsed: NameValues.PROVIDER_ID,
    columns: [
      {
        uiKey: ColumnKeys.T1Provider,
        key: NameValues.PROVIDER_ID,
        value: jitTranslations.provider,
        sortable: false,
        resize: true,
        tooltipInfo: jitTranslations.T1ProviderTooltip
      },
      {
        uiKey: ColumnKeys.providerBusinessName,
        key: NameValues.PROVIDER_NAME,
        value: jitTranslations.providerBusinessName,
        sortable: false,
        resize: true,
        tooltipInfo: jitTranslations.providerBusinessName
      }
      /* {
        uiKey: ColumnKeys.T1Stock,
        key: NameValues.PROVIDER_STOCK,
        value: jitTranslations.T1Stock,
        sortable: false,
        resize: true,
        align: 'right'
      },
      {
        uiKey: ColumnKeys.T1Updated,
        key: NameValues.LAST_UPDATED,
        value: jitTranslations.T1Updated,
        sortable: false,
        resize: true,
        tooltipInfo: jitTranslations.T1UpdatedTooltip
      }*/
    ]
  },
  {
    key: NameValues.PROVIDER_TYPE,
    value: jitTranslations.type,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.providerType,
        key: NameValues.PROVIDER_TYPE,
        value: jitTranslations.type,
        sortable: false,
        tooltipInfo: jitTranslations.typeTooltip
      }
    ]
  },
  {
    key: NameValues.MODELS,
    value: jitTranslations.models,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.models,
        key: NameValues.MODELS,
        value: jitTranslations.models,
        sortable: false,
        tooltipInfo: jitTranslations.modelCarRelation
      }
    ]
  },
  // Column M100 Launches
  {
    key: NameValues.M100_LAUNCHES_COUNT,
    value: jitTranslations.m100LaunchesCount,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.m100LaunchesCount,
        key: NameValues.M100_LAUNCHES_COUNT,
        value: jitTranslations.m100LaunchesCount,
        sortable: true,
        resize: true
      }
    ]
  },

  // Column Stock (sequence)
  {
    key: NameValues.STOCK_SEQUENCE,
    value: jitTranslations.stockSequence,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.stockSequence,
        key: NameValues.STOCK_SEQUENCE,
        value: jitTranslations.stockSequence,
        sortable: true,
        resize: true
      }
    ]
  },

  // Column Coverage (sequence)
  {
    key: NameValues.COVERAGE_SEQUENCE,
    value: jitTranslations.coverageSequence,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.coverageSequence,
        key: NameValues.COVERAGE_SEQUENCE,
        value: jitTranslations.coverageSequence,
        sortable: true,
        resize: true
      }
    ]
  },

  // Column Coverage (date & time)
  {
    key: NameValues.COVERAGE_STOPPED_AT,
    value: jitTranslations.coverageStoppedAt,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.coverageStoppedAt,
        key: NameValues.COVERAGE_STOPPED_AT,
        value: jitTranslations.coverageStoppedAt,
        sortable: true,
        resize: true
      }
    ]
  }

  // Column Line stoppage (date & time)
  /**{
    key: NameValues.LINE_STOPPED_AT,
    value: jitTranslations.lineStoppedAt,
    headerVisible: false,
    headerSpan: 1,
    isVisibleCheck: true,
    columns: [
      {
        uiKey: ColumnKeys.lineStoppedAt,
        key: NameValues.LINE_STOPPED_AT,
        value: jitTranslations.lineStoppedAt,
        sortable: true,
        resize: true
      }
    ]
  }*/
];
